import { PortFacilityModel } from './port-facility.model';
import { BaseModel } from '@seahorse/common';
import { ValidationResult } from '@seahorse/common';
import { HarbourModel } from './harbour.model';
import { PortModel } from './port.model';
import {
  CoordinatePointModel,
  CoordinatePolygonModel,
} from '../../nautical-geography/models/coordinate.model';

export class PortWaypointModel extends BaseModel {
  name: string;
  waypointType: WaypointTypes;
  code: string;
  number: string;
  portId: number;
  port: PortModel;
  harbour: HarbourModel;
  portFacility: PortFacilityModel;
  harbourId: number;
  portFacilityId: number;
  centerPoint: CoordinatePointModel;
  boundary: CoordinatePolygonModel;

  hasCenterpoint: boolean;
  hasPolygon: boolean;

  static validate(portWaypoint: PortWaypointModel) {
    if (
      !portWaypoint.name ||
      !portWaypoint.waypointType ||
      !portWaypoint.portId
    ) {
      return false;
    }

    portWaypoint.name = portWaypoint.name.trim();
    if (portWaypoint.name === '') {
      portWaypoint.name = null;
      return false;
    }

    return true;
  }

  validate(errorPrefix?: string): ValidationResult {
    const result: ValidationResult = new ValidationResult();

    if (!errorPrefix) {
      errorPrefix = '';
    }

    if (this.name == null) {
      result.errors.push(errorPrefix + 'Name is required!');
    }

    this.name = this.name.trim();
    if (this.name === '') {
      this.name = null;
      result.errors.push(errorPrefix + 'Name is required!');
    }

    if (this.portId == null || this.portId === undefined) {
      result.errors.push(errorPrefix + 'Port is required!');
    }

    if (this.waypointType == null || this.waypointType === undefined) {
      result.errors.push(errorPrefix + 'Waypoint type is required!');
    }

    result.isValid = result.errors.length === 0;
    return result;
  }
}

export enum WaypointTypes {
  Quay = 1,
  Dock = 2,
  Buoy = 3,
  Dolphin = 4,
  EntryPoint = 5,
  Unknown = 255,
}
